import React, { useState } from "react";
import ConfirmPasswordModal from "./ConfirmPasswordModal";

const MessagesTable = ({ messages, selectedUsers, toggleUserSelection, toggleSelectAll, viewDetails, deleteClient }) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [messageToDelete, setMessageToDelete] = useState(null);

  // ✅ Trigger modal for delete confirmation
  const handleDelete = (messageId) => {
    setMessageToDelete(messageId);
    setShowConfirmModal(true);
  };

  // ✅ Execute delete after confirmation
  const confirmDelete = () => {
    if (messageToDelete) {
      deleteClient(messageToDelete); // Call delete function passed via props
      setMessageToDelete(null);
      setShowConfirmModal(false);
    }
  };

  return (
    <div className="browse_client_table_body">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>
              <label className="cl-checkbox">
                <input
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={selectedUsers.length === messages.length && messages.length > 0}
                />
                <span></span>
              </label>
            </th>
            <th>Name</th>
            <th>Email</th>
            <th>Subject</th>
            <th>Sent On</th>
            <th>Time</th>
            <th>Manage</th>
          </tr>
        </thead>
        <tbody>
          {messages.length > 0 ? (
            messages.map((message) => (
              <tr key={message._id}>
                <td>
                  <label className="cl-checkbox">
                    <input
                      type="checkbox"
                      checked={selectedUsers.includes(message._id)}
                      onChange={() => toggleUserSelection(message._id)}
                    />
                    <span></span>
                  </label>
                </td>
                <td>{message.name}</td>
                <td>{atob(message.email)}</td>
                <td>{message.subject}</td>
                <td>
                  {message.created_at
                    ? new Date(message.created_at).toISOString().split("T")[0].replace(/-/g, "/")
                    : "N/A"}
                </td>
                <td>
                  {message.created_at
                    ? new Date(message.created_at).toISOString().split("T")[1].split(".")[0]
                    : "N/A"}
                </td>
                <td>
                  <div className="share_dtls_btn_holder">
                    <button
                      type="button"
                      className="rounded_action"
                      onClick={() => viewDetails(message.message)}
                    >
                      <span><i className="fa-solid fa-eye"></i></span>
                    </button>
                    <button
                      type="button"
                      className="rounded_action"
                      onClick={() => handleDelete(message._id)} // ✅ Trigger delete confirmation
                    >
                      <span><i className="fa-solid fa-user-minus"></i></span>
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center", padding: "10px" }}>
                No Data Available
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* ✅ Confirm Password Modal */}
      <ConfirmPasswordModal
        show={showConfirmModal}
        onClose={() => setShowConfirmModal(false)}
        onSuccess={confirmDelete}
      />
    </div>
  );
};

export default MessagesTable;
